/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Body_Assessment_RecomputedInputs */

const en_us2_body_assessment_recomputed = /** @type {(inputs: Body_Assessment_RecomputedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Recomputed on ${i?.date}, with a newer version of the calculation. Your body did not change: the maths did.`)
};

const pt_br2_body_assessment_recomputed = /** @type {(inputs: Body_Assessment_RecomputedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Recalculada em ${i?.date}, com uma versão nova do cálculo. O seu corpo não mudou: a conta mudou.`)
};

const es_419_body_assessment_recomputed = /** @type {(inputs: Body_Assessment_RecomputedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Recalculada el ${i?.date}, con una versión más nueva del cálculo. Tu cuerpo no cambió: cambió la cuenta.`)
};

const pt_pt2_body_assessment_recomputed = /** @type {(inputs: Body_Assessment_RecomputedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Recalculada em ${i?.date}, com uma versão nova do cálculo. O teu corpo não mudou: a conta é que mudou.`)
};

const fr_fr2_body_assessment_recomputed = /** @type {(inputs: Body_Assessment_RecomputedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Recalculée le ${i?.date}, avec une version plus récente du calcul. Ton corps n'a pas changé : les maths, si.`)
};

const de_de2_body_assessment_recomputed = /** @type {(inputs: Body_Assessment_RecomputedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Am ${i?.date} mit einer neueren Version der Berechnung neu berechnet. Dein Körper hat sich nicht verändert, nur die Mathematik.`)
};

const it_it2_body_assessment_recomputed = /** @type {(inputs: Body_Assessment_RecomputedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ricalcolata il ${i?.date}, con una versione più recente del calcolo. Il tuo corpo non è cambiato: è cambiata la matematica.`)
};

/**
* | output |
* | --- |
* | "Recomputed on {date}, with a newer version of the calculation. Your body did not change: the maths did." |
*
* @param {Body_Assessment_RecomputedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_recomputed = /** @type {((inputs: Body_Assessment_RecomputedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_RecomputedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_recomputed(inputs)
	if (locale === "es-419") return es_419_body_assessment_recomputed(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_recomputed(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_recomputed(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_recomputed(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_recomputed(inputs)
	return en_us2_body_assessment_recomputed(inputs)
});
export { body_assessment_recomputed as "body-assessment.recomputed" }